module.exports = __webpack_public_path__ + "static/img/Bahu shoulder 15 cm & 35 cm DSK.36d946f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Bahu shoulder 15 cm & 35 cm DSK.jpg
// module id = 77
// module chunks = 1